export default __webpack_public_path__ + "static/media/inter-removebg-preview1.65defb13.svg";